import Drawer from './src/main';

/* istanbul ignore next */
Drawer.install = function(Vue) {
  Vue.component(Drawer.name, Drawer);
};

export default Drawer;



// WEBPACK FOOTER //
// ./src/components/element/packages/drawer/index.js